/**
 * Utility to handle image URLs
 * Handles both absolute URLs (https://...) and relative paths (/api/uploads/...)
 */

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Get the full URL for an image
 * @param {string} imagePath - Can be absolute URL or relative path
 * @returns {string} Full URL to the image
 */
export function getImageUrl(imagePath) {
  if (!imagePath) return "";
  
  // If it's already an absolute URL (starts with http:// or https://), return as-is
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }
  
  // If it's a relative path starting with /, prepend the API URL
  if (imagePath.startsWith("/")) {
    return `${API_URL}${imagePath}`;
  }
  
  // Otherwise, assume it needs the API URL prefix
  return `${API_URL}/${imagePath}`;
}

/**
 * Process an array of images to get full URLs
 * @param {string[]} images - Array of image paths
 * @returns {string[]} Array of full URLs
 */
export function getImageUrls(images) {
  if (!images || !Array.isArray(images)) return [];
  return images.map(getImageUrl);
}

export default { getImageUrl, getImageUrls };
